module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-left-black-1bbca1c94511cf435b9761555aab4b2f.png";